module.exports = __webpack_public_path__ + "img/0Q3A3494_L_BlackMatted.d1019b70.jpg";